import Swiper, { Navigation, Pagination } from 'swiper';

function IconsB1() {
    Swiper.use([Navigation, Pagination]);

    const breakpoint = 768; // Only activate slider when viewport width is below 768px

    function initSwiperForModule(module) {
        const swiper = new Swiper(module.find('[data-slider]')[0], {
            slidesPerView: 1,
            spaceBetween: 16,
            noSwipingSelector: 'a',
            navigation: {
                prevEl: module.find('.js-slider-prev')[0],
                nextEl: module.find('.js-slider-next')[0],
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
            },
        });

        // Save the instance on the module so we can reference it later
        module.data('swiperInstance', swiper);

        swiper.on('progress', function (e, progress) {
            if (progress <= 0) {
                module
                    .find('.js-slider-prev')
                    .addClass('a-btn-pagination--disabled');
            } else {
                module
                    .find('.js-slider-prev')
                    .removeClass('a-btn-pagination--disabled');
            }

            if (progress >= 1) {
                module
                    .find('.js-slider-next')
                    .addClass('a-btn-pagination--disabled');
            } else {
                module
                    .find('.js-slider-next')
                    .removeClass('a-btn-pagination--disabled');
            }
        });

        if (swiper.isBeginning) {
            module
                .find('.js-slider-prev')
                .addClass('a-btn-pagination--disabled');
        }

        if (swiper.isEnd) {
            module
                .find('.js-slider-next')
                .addClass('a-btn-pagination--disabled');
        }
    }

    function destroySwiperForModule(module) {
        const swiper = module.data('swiperInstance');
        if (swiper) {
            swiper.destroy(true, true);
            module.removeData('swiperInstance');
        }
    }

    function checkBreakpoint() {
        $('[data-module="iconsB1"]').each(function () {
            const module = $(this);
            if (window.innerWidth < breakpoint) {
                // Initialize the slider if it hasn’t been already
                if (!module.data('swiperInstance')) {
                    initSwiperForModule(module);
                }
            } else {
                // Destroy the slider if it exists
                if (module.data('swiperInstance')) {
                    destroySwiperForModule(module);
                }
            }
        });
    }

    // Check on initial load
    $(document).ready(checkBreakpoint);
    // Check on window resize
    $(window).on('resize', checkBreakpoint);
}

export default IconsB1;
